import React from 'react';

const Russia = (props) => (
<img src="https://flagsapi.com/RU/flat/64.png" style={{filter:"brightness(0.86)"}} width={40} height={'auto'} />
);

export default Russia;
